<div class="module-config-page">
  <!-- ====================================================== -->
  <!-- PAGE HEADER -->
  <!-- ====================================================== -->

  <div class="page-header">
    <div>
      <div class="page-eyebrow">SYSTEM CONFIGURATION</div>

      <h2 class="page-title">Module Config</h2>

      <p class="page-subtitle">
        Configure application menus and assign them to roles.
      </p>
    </div>

    <button
      type="button"
      class="btn-refresh"
      (click)="loadInitialData()"
      [disabled]="isLoading"
    >
      <i class="bi bi-arrow-clockwise"></i>

      Refresh
    </button>
  </div>

  <!-- ====================================================== -->
  <!-- LOADER -->
  <!-- ====================================================== -->

  <div class="loading-panel" *ngIf="isLoading">
    <div class="spinner-border spinner-border-sm" role="status"></div>

    <span> Loading module configuration... </span>
  </div>

  <!-- ====================================================== -->
  <!-- TABS -->
  <!-- ====================================================== -->

  <div class="config-tabs">
    <button
      type="button"
      class="config-tab"
      [class.active]="activeTab === 'menu'"
      (click)="setTab('menu')"
    >
      <i class="bi bi-grid-3x3-gap"></i>

      Menu Master
    </button>

    <button
      type="button"
      class="config-tab"
      [class.active]="activeTab === 'mapping'"
      (click)="setTab('mapping')"
    >
      <i class="bi bi-diagram-3"></i>

      Role Menu Mapping
    </button>
  </div>

  <!-- ====================================================== -->
  <!-- SCREEN 1 : MENU MASTER -->
  <!-- ====================================================== -->

  <div *ngIf="activeTab === 'menu'" class="tab-content-wrap">
    <!-- MODULE SELECTOR -->

    <div class="module-selector-card">
      <div class="selector-icon">
        <i class="bi bi-boxes"></i>
      </div>

      <div class="selector-content">
        <label> Select Module </label>

        <select
          class="form-select"
          [(ngModel)]="selectedMenuModuleKey"
          (ngModelChange)="onMenuModuleChange()"
        >
          <option value="">Select Module</option>

          <option *ngFor="let module of modules" [value]="module.key">
            {{ module.moduleLabel }}
          </option>
        </select>
      </div>

      <div class="module-summary" *ngIf="selectedMenuModule">
        <span> Module </span>

        <strong>
          {{ selectedMenuModule?.moduleLabel }}
        </strong>
      </div>

      <div class="module-summary" *ngIf="selectedMenuModule">
        <span> Menus </span>

        <strong>
          {{ moduleMenus.length }}
        </strong>
      </div>
    </div>

    <!-- FORM + LIST -->

    <div class="config-grid">
      <!-- ================================================== -->
      <!-- MENU CREATE / UPDATE -->
      <!-- ================================================== -->

      <div class="config-card form-card">
        <div class="card-heading">
          <div>
            <span class="heading-icon">
              <i
                class="bi"
                [ngClass]="
                  menuForm.menuId > 0 ? 'bi-pencil-square' : 'bi-plus-circle'
                "
              ></i>
            </span>

            <div>
              <h5>
                {{ menuForm.menuId > 0 ? "Edit Menu" : "Create Menu" }}
              </h5>

              <p>
                {{
                  menuForm.menuId > 0
                    ? "Update existing menu configuration"
                    : "Add a new parent menu or submenu"
                }}
              </p>
            </div>
          </div>

          <button
            *ngIf="menuForm.menuId > 0"
            type="button"
            class="btn-text"
            (click)="resetMenuForm()"
          >
            <i class="bi bi-x-lg"></i>

            Cancel
          </button>
        </div>

        <div class="selected-module-banner" *ngIf="selectedMenuModule">
          <i class="bi bi-box"></i>

          <span> Creating menu under </span>

          <strong>
            {{ selectedMenuModule?.moduleLabel }}
          </strong>
        </div>

        <div class="empty-selection" *ngIf="!selectedMenuModule">
          <i class="bi bi-info-circle"></i>

          Select a module before creating a menu.
        </div>

        <div class="form-section" *ngIf="selectedMenuModule">
          <div class="row g-3">
            <!-- MENU NAME -->

            <div class="col-md-6">
              <label class="form-label">
                Menu Name
                <span>*</span>
              </label>

              <input
                type="text"
                class="form-control"
                maxlength="50"
                placeholder="Example: Attendance"
                [(ngModel)]="menuForm.menuName"
                (blur)="fillMenuDefaults()"
              />
            </div>

            <!-- MENU CODE -->

            <div class="col-md-6">
              <label class="form-label">
                Menu Code
                <span>*</span>
              </label>

              <input
                type="text"
                class="form-control"
                maxlength="50"
                placeholder="Example: attendance"
                [(ngModel)]="menuForm.menuCode"
              />
            </div>

            <!-- PARENT MENU -->

            <div class="col-md-6">
              <label class="form-label"> Parent Menu </label>

              <select class="form-select" [(ngModel)]="menuForm.parentMenuId">
                <option [ngValue]="0">Root / Parent Menu</option>

                <option
                  *ngFor="let menu of parentMenuOptions"
                  [ngValue]="menu.menuId"
                >
                  {{ menu.menuName }}
                </option>
              </select>

              <div class="field-help">Keep Root if this is a main menu.</div>
            </div>

            <!-- DISPLAY ORDER -->

            <div class="col-md-6">
              <label class="form-label"> Display Order </label>

              <input
                type="number"
                class="form-control"
                min="0"
                [(ngModel)]="menuForm.displayOrder"
              />
            </div>

            <!-- TEMPLATE PATH -->

            <div class="col-md-8">
              <label class="form-label"> Template / Route Path </label>

              <input
                type="text"
                class="form-control"
                maxlength="500"
                placeholder="/attendance"
                [(ngModel)]="menuForm.templatePath"
              />
            </div>

            <!-- ICON -->

            <div class="col-md-4">
              <label class="form-label"> Icon </label>

              <div class="icon-input">
                <span class="icon-preview">
                  <i [class]="menuForm.menuIconUrl || 'bi bi-grid'"></i>
                </span>

                <input
                  type="text"
                  class="form-control"
                  maxlength="500"
                  placeholder="bi bi-grid"
                  [(ngModel)]="menuForm.menuIconUrl"
                />
              </div>
            </div>

            <!-- DEFAULT CHILD -->

            <div class="col-md-6" *ngIf="menuForm.menuId > 0">
              <label class="form-label"> Default Child Menu </label>

              <select
                class="form-select"
                [(ngModel)]="menuForm.defaultChildMenuId"
              >
                <option [ngValue]="0">No Default Child</option>

                <option
                  *ngFor="let child of defaultChildOptions"
                  [ngValue]="child.menuId"
                >
                  {{ child.menuName }}
                </option>
              </select>
            </div>

            <!-- STATUS -->

            <div class="col-md-6" *ngIf="menuForm.menuId > 0">
              <label class="form-label"> Status </label>

              <select class="form-select" [(ngModel)]="menuForm.isActive">
                <option [ngValue]="1">Active</option>

                <option [ngValue]="0">Inactive</option>
              </select>
            </div>

            <!-- DESCRIPTION -->

            <div class="col-12">
              <label class="form-label"> Description </label>

              <textarea
                class="form-control"
                rows="3"
                maxlength="500"
                placeholder="Short menu description"
                [(ngModel)]="menuForm.menuDesc"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="form-actions" *ngIf="selectedMenuModule">
          <button
            type="button"
            class="btn-secondary-action"
            (click)="resetMenuForm()"
            [disabled]="isSavingMenu"
          >
            Clear
          </button>

          <button
            type="button"
            class="btn-primary-action"
            (click)="saveMenu()"
            [disabled]="isSavingMenu"
          >
            <span
              *ngIf="isSavingMenu"
              class="spinner-border spinner-border-sm"
            ></span>

            <i
              *ngIf="!isSavingMenu"
              class="bi"
              [ngClass]="
                menuForm.menuId > 0 ? 'bi-check2-circle' : 'bi-plus-lg'
              "
            ></i>

            {{
              isSavingMenu
                ? "Saving..."
                : menuForm.menuId > 0
                  ? "Update Menu"
                  : "Create Menu"
            }}
          </button>
        </div>
      </div>

      <!-- ================================================== -->
      <!-- MENU LIST -->
      <!-- ================================================== -->

      <div class="config-card list-card">
        <div class="card-heading">
          <div>
            <span class="heading-icon">
              <i class="bi bi-list-ul"></i>
            </span>

            <div>
              <h5>Menu Structure</h5>

              <p>Menus configured for selected module</p>
            </div>
          </div>
        </div>

        <div class="search-row">
          <div class="search-box">
            <i class="bi bi-search"></i>

            <input
              type="text"
              placeholder="Search menu, code or route..."
              [(ngModel)]="menuSearch"
            />
          </div>
        </div>

        <div class="menu-list" *ngIf="filteredModuleMenus.length > 0">
          <div class="menu-row" *ngFor="let menu of filteredModuleMenus">
            <div class="menu-main">
              <div class="menu-icon-box">
                <i [class]="menu.menuIconUrl || 'bi bi-grid'"></i>
              </div>

              <div class="menu-info">
                <div class="menu-title-line">
                  <strong>
                    {{ menu.menuName }}
                  </strong>

                  <span
                    class="menu-type-badge root"
                    *ngIf="menu.parentMenuId === 0"
                  >
                    Parent
                  </span>

                  <span
                    class="menu-type-badge child"
                    *ngIf="menu.parentMenuId > 0"
                  >
                    Sub Menu
                  </span>
                </div>

                <div class="menu-meta">
                  <span> #{{ menu.menuId }} </span>

                  <span>
                    {{ menu.menuCode }}
                  </span>

                  <span> Order {{ menu.displayOrder }} </span>
                </div>

                <div class="menu-parent" *ngIf="menu.parentMenuId > 0">
                  <i class="bi bi-arrow-return-right"></i>

                  Parent:
                  {{ getMenuName(menu.parentMenuId) }}
                </div>

                <div class="menu-path">
                  <i class="bi bi-link-45deg"></i>

                  {{ menu.templatePath || "No route" }}
                </div>
              </div>
            </div>

            <div class="row-actions">
              <button
                type="button"
                class="icon-action edit"
                title="Edit"
                (click)="editMenu(menu)"
              >
                <i class="bi bi-pencil"></i>
              </button>

              <button
                type="button"
                class="icon-action delete"
                title="Delete"
                (click)="deleteMenu(menu)"
              >
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <div
          class="empty-state"
          *ngIf="!selectedMenuModuleKey || filteredModuleMenus.length === 0"
        >
          <div class="empty-icon">
            <i class="bi bi-folder2-open"></i>
          </div>

          <h6>No menus found</h6>

          <p>Select a module or create the first menu.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ====================================================== -->
  <!-- SCREEN 2 : ROLE MENU MAPPING -->
  <!-- ====================================================== -->

  <div *ngIf="activeTab === 'mapping'" class="tab-content-wrap">
    <div class="mapping-workflow">
      <div class="workflow-title">
        <div>
          <h5>Role Menu Mapping</h5>

          <p>Select module → role → parent menu → submenu.</p>
        </div>
      </div>

      <div class="workflow-grid">
        <!-- STEP 1 -->

        <div class="workflow-step">
          <div class="step-number">1</div>

          <label> Module </label>

          <select
            class="form-select"
            [(ngModel)]="selectedMappingModuleKey"
            (ngModelChange)="onMappingModuleChange()"
          >
            <option value="">Select Module</option>

            <option *ngFor="let module of modules" [value]="module.key">
              {{ module.moduleLabel }}
            </option>
          </select>
        </div>

        <!-- STEP 2 -->

        <div class="workflow-step">
          <div class="step-number">2</div>

          <label> Role </label>

          <select
            class="form-select"
            [(ngModel)]="selectedRoleId"
            (ngModelChange)="onRoleChange()"
            [disabled]="!selectedMappingModuleKey"
          >
            <option [ngValue]="0">Select Role</option>

            <option *ngFor="let role of mappingRoles" [ngValue]="role.roleId">
              {{ role.roleName }}
              ({{ role.roleId }})
            </option>
          </select>
        </div>

        <!-- STEP 3 -->

        <div class="workflow-step">
          <div class="step-number">3</div>

          <label> Parent Menu </label>

          <select class="form-select" [(ngModel)]="menuForm.parentMenuId">
            <option [ngValue]="0">Root / Parent Menu</option>

            <option
              *ngFor="let menu of parentMenuOptions"
              [ngValue]="menu.menuId"
            >
              {{ menu.menuName }}
              ({{ menu.menuId }})
            </option>
          </select>
        </div>

        <!-- STEP 4 -->

        <div class="workflow-step">
          <div class="step-number">4</div>

          <label>
            Sub Menu
            <span class="optional"> Optional </span>
          </label>

          <select
            class="form-select"
            [(ngModel)]="selectedSubMenuId"
            [disabled]="!selectedParentMenuId"
          >
            <option [ngValue]="0">Parent Menu Only</option>

            <option
              *ngFor="let menu of mappingSubMenus"
              [ngValue]="menu.menuId"
            >
              {{ menu.menuName }}
            </option>
          </select>
        </div>
      </div>

      <div class="workflow-footer">
        <div class="workflow-hint">
          <i class="bi bi-info-circle"></i>

          When a submenu is selected, its parent menu is also mapped
          automatically.
        </div>

        <button
          type="button"
          class="btn-primary-action"
          (click)="assignMenuToRole()"
          [disabled]="
            isSavingMapping || !selectedRoleId || !selectedParentMenuId
          "
        >
          <span
            *ngIf="isSavingMapping"
            class="spinner-border spinner-border-sm"
          ></span>

          <i *ngIf="!isSavingMapping" class="bi bi-plus-lg"></i>

          {{ isSavingMapping ? "Assigning..." : "Assign Menu" }}
        </button>
      </div>
    </div>

    <!-- ====================================================== -->
    <!-- MAPPED MENUS LIST -->
    <!-- ====================================================== -->

    <div class="config-card mapping-list-card" *ngIf="selectedRoleId > 0">
      <div class="card-heading">
        <div>
          <span class="heading-icon">
            <i class="bi bi-diagram-3"></i>
          </span>

          <div>
            <h5>Assigned Menus</h5>

            <p>Current menu access for selected role</p>
          </div>
        </div>

        <div class="mapping-count">
          {{ mappedRoleMenus.length }}

          menu(s)
        </div>
      </div>

      <div class="search-row">
        <div class="search-box">
          <i class="bi bi-search"></i>

          <input
            type="text"
            placeholder="Search assigned menus..."
            [(ngModel)]="mappingSearch"
          />
        </div>
      </div>

      <div class="loading-panel inline" *ngIf="isLoadingMappings">
        <div class="spinner-border spinner-border-sm"></div>

        Loading assigned menus...
      </div>

      <div
        class="table-responsive"
        *ngIf="!isLoadingMappings && mappedRoleMenus.length > 0"
      >
        <table class="config-table">
          <thead>
            <tr>
              <th>Menu</th>

              <th>Type</th>

              <th>Parent</th>

              <th>Route</th>

              <th>Order</th>

              <th>Status</th>

              <th class="text-end">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of mappedRoleMenus">
              <td>
                <div class="table-menu">
                  <strong>
                    {{ row.menuName }}
                  </strong>

                  <small>
                    {{ row.menuCode }}
                  </small>
                </div>
              </td>

              <td>
                <span
                  class="menu-type-badge root"
                  *ngIf="row.parentMenuId === 0"
                >
                  Parent
                </span>

                <span
                  class="menu-type-badge child"
                  *ngIf="row.parentMenuId > 0"
                >
                  Sub Menu
                </span>
              </td>

              <td>
                {{ row.parentMenuName }}
              </td>

              <td>
                <code>
                  {{ row.templatePath || "-" }}
                </code>
              </td>

              <td>
                {{ row.displayOrder }}
              </td>

              <td>
                <span class="status-badge active" *ngIf="row.isActive === 1">
                  Active
                </span>

                <span class="status-badge inactive" *ngIf="row.isActive !== 1">
                  Inactive
                </span>
              </td>

              <td class="text-end">
                <button
                  type="button"
                  class="table-action disable"
                  title="Disable Mapping"
                  (click)="disableRoleMenu(row)"
                >
                  <i class="bi bi-pause-circle"></i>
                </button>

                <button
                  type="button"
                  class="table-action delete"
                  title="Remove Mapping"
                  (click)="removeRoleMenu(row)"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="empty-state"
        *ngIf="!isLoadingMappings && mappedRoleMenus.length === 0"
      >
        <div class="empty-icon">
          <i class="bi bi-diagram-2"></i>
        </div>

        <h6>No menus assigned</h6>

        <p>Select a parent menu or submenu above and assign it to this role.</p>
      </div>
    </div>

    <div class="mapping-placeholder" *ngIf="selectedRoleId === 0">
      <i class="bi bi-person-lock"></i>

      <h5>Select a role</h5>

      <p>Assigned menus will appear here after selecting a module and role.</p>
    </div>
  </div>
</div>
